/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
    const moneyFormat = '${{amount}}';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) return '0';

        const parts = (number / 100).toFixed(precision).split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
    }

    function formatMoney(cents, format) {
        const formatString = format || moneyFormat;
        const match = formatString.match(placeholderRegex);
        if (!match) return formatWithDelimiters(cents);

        let value = '';
        switch (match[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'", '.');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ', '');
                break;
            case 'amount_with_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', ',');
                break;
            case 'amount_with_period_and_space_separator':
                value = formatWithDelimiters(cents, 2, ' ', '.');
                break;
            default:
                value = formatWithDelimiters(cents, 2);
        }

        const formatted = document.createElement('template');
        formatted.innerHTML = formatString.replace(placeholderRegex, value);
        return formatted.content.textContent.trim();
    }

    function updateOptionCardPrices(scope) {
        const root = scope instanceof Element ? scope : document;
        const productRoots = root.matches && root.matches('[data-product]')
            ? [root]
            : Array.from(root.querySelectorAll('[data-product]'));

        productRoots.forEach((productRoot) => {
            const section = productRoot.closest('[data-section-id]') || productRoot.parentElement;
            const productJsonElement = section && section.querySelector('[data-product-json]');
            const variantsRoot = productRoot.querySelector('[data-product-variants]');

            if (!productJsonElement || !variantsRoot) return;

            let productData;
            try {
                productData = JSON.parse(productJsonElement.textContent);
            } catch (error) {
                return;
            }

            if (!productData || !Array.isArray(productData.variants)) return;

            const optionWrappers = Array.from(variantsRoot.querySelectorAll('[data-option-position]'))
                .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
            const selections = optionWrappers.map((wrapper) => {
                const selected = wrapper.querySelector('[data-single-option-selector]:checked, [data-single-option-selector][type="hidden"]');
                return selected ? selected.value : null;
            });

            variantsRoot.querySelectorAll('[data-option-card-input]').forEach((input) => {
                const wrapper = input.closest('[data-option-position]');
                const card = input.closest('.product-option-card, .luna-pack-card');
                if (!wrapper || !card) return;

                const position = Number(wrapper.dataset.optionPosition) - 1;
                const candidateOptions = [...selections];
                candidateOptions[position] = input.value;
                const variant = productData.variants.find((item) =>
                    item.options.every((optionValue, index) => optionValue === candidateOptions[index])
                );
                const price = card.querySelector('[data-option-card-price]');
                const comparePrice = card.querySelector('[data-option-card-compare-price]');
                const savings = card.querySelector('[data-option-card-savings]');
                const savingsAmount = card.querySelector('[data-option-card-savings-amount]');
                const optionMoneyFormat = variantsRoot.dataset.optionMoneyFormat || (window.theme && window.theme.moneyFormat);
                const hasSavings = Boolean(variant && variant.compare_at_price > variant.price);
                if (savings) savings.classList.toggle('hidden', !hasSavings);
                if (savingsAmount) savingsAmount.textContent = hasSavings
                    ? formatMoney(variant.compare_at_price - variant.price, optionMoneyFormat)
                    : '';


                if (!variant || !price || !comparePrice) return;

                price.textContent = formatMoney(variant.price, optionMoneyFormat);

                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    comparePrice.textContent = formatMoney(variant.compare_at_price, optionMoneyFormat);
                    comparePrice.classList.remove('hidden');
                } else {
                    comparePrice.textContent = '';
                    comparePrice.classList.add('hidden');
                }
            });
        });
    }

    function refreshOptionCards(target) {
        const scope = target instanceof Element
            ? target.closest('[data-section-id]') || target.closest('[data-product]') || document
            : document;
        updateOptionCardPrices(scope);
    }

    function updateSelectionNames(root) {
        root.querySelectorAll('[data-option-position]').forEach((wrapper) => {
            const selected = wrapper.querySelector('[data-single-option-selector]:checked, select[data-single-option-selector], [data-single-option-selector][type="hidden"]');
            const label = wrapper.querySelector('.mb-option-selection');
            if (selected && label) label.textContent = selected.value;
        });
    }

    function updateSavings(root, variant) {
        const discounted = variant && variant.compare_at_price > variant.price;
        root.querySelectorAll('[data-variant-savings]').forEach((savings) => {
            const amount = savings.querySelector('[data-variant-savings-amount]');
            savings.classList.toggle('hidden', !discounted);
            if (amount) amount.textContent = discounted
                ? formatMoney(variant.compare_at_price - variant.price, window.theme && window.theme.moneyFormat)
                : '';
        });
        root.querySelectorAll('[data-variant-discount]').forEach((badge) => {
            const amount = badge.querySelector('[data-variant-discount-amount]');
            badge.classList.toggle('hidden', !discounted);
            if (amount) amount.textContent = discounted
                ? `${Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price / 5) * 5}%`
                : '';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => updateOptionCardPrices(document));
    } else {
        updateOptionCardPrices(document);
    }

    document.addEventListener('change', (event) => {
        if (!(event.target instanceof Element) || !event.target.matches('[data-single-option-selector]')) return;
        const scope = event.target.closest('[data-product]') || event.target.closest('[data-section-id]') || document;
        updateSelectionNames(scope);
        requestAnimationFrame(() => refreshOptionCards(event.target));
    });

    document.addEventListener('shopify:section:load', (event) => {
        updateSelectionNames(event.target);
        updateOptionCardPrices(event.target);
    });

    document.addEventListener('theme:variant:change', (event) => {
        const target = event.target;
        const product = target instanceof Element ? target.closest('[data-product]') || target : document;
        const variant = event.detail && event.detail.variant;
        updateSelectionNames(product);
        updateSavings(product, variant);
        refreshOptionCards(target);
    });
})();
